<template>
    <v-avatar v-if="nationalityCode && showImage" :size="size ? size : '40px'" class="flag-border">
        <img :src="imagePath" @error="imageError()">
    </v-avatar>
</template>

<script>

export default {
    props: [
        'nationalityCode',
        'size'
    ],
    data () {
        return {
            showImage: true
        }
    },
    methods: {
        //Not every country has a flag in the bucket. Without this an absent one
        //renders as a broken image icon next to the member's name.
        imageError () {
            this.showImage = false
        }
    },
    computed: {
        imagePath () {
            return this.assets() + '/flags/' + this.nationalityCode.toUpperCase() + '.png'
        }
    }
}
</script>

<style scoped>
.flag-border{
  border: 1px solid black;
}
</style>
